module.exports = __webpack_public_path__ + "static/img/station03.43fa274b.png";